module.exports = __webpack_public_path__ + "img/location_512x512.db0ed3a3.png";